/* megamenu */
$(".collection_info_links_new").hover(function(){
  var ID = $(this).attr("menu_id");
  if(ID)
  {
    setTimeout(function(){
      $(".megamenu_right_collection_Info_new").css("display","none");
    	$("."+ID+"_display").css("display","block");
    }, 200);
  }
  $(".collection_info_links_new").removeClass("active");
  $(this).addClass("active");
})

$(".custom_mega_menu_top_only_new").hover(function(){
  $(this).find(".mega-menu").attr("open","open");
  $('body').addClass("open_megamenu");
  $(".overlay").css("display","block");
}, function(){
  $(this).find(".mega-menu").removeAttr("open");
  $('body').removeClass("open_megamenu");
  $(".overlay").css("display","none");
  setTimeout(function(){
    $(".megamenu_right_collection_Info_new").css("display","none");
    $(".first_element_in_loop_new").css("display","block");
    
    $(".collection_info_links_new").removeClass("active");
    $(".first_item_in_loop_new").addClass("active");
  }, 200);
})

$(".single_menu_top_new").hover(function(){
  $(this).find(".mega-menu").attr("open","open");
}, function(){
  $(this).find(".mega-menu").removeAttr("open");
})

$(".customSubMenuWrap").hover(function(){
  $(this).find(".customButtonItem").css("display","block");
}, function(){
  $(this).find(".customButtonItem").css("display","none");
})

$(".Index_dots_bundle_details_sides_innerright_innerdesktop_innerboxs_1_new").hover(function() {
  $(".Index_dots_bundle_details_sides_innerright_innerdesktop_innerboxs_2_new").css("display","none");
  $(this).next(".Index_dots_bundle_details_sides_innerright_innerdesktop_innerboxs_2_new").css("display","block");
})

$(document).mouseup(function(e) 
{
    var container = $(".Index_dots_bundle_details_sides_innerright_innerdesktop_innerboxs_new");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        $(".Index_dots_bundle_details_sides_innerright_innerdesktop_innerboxs_2_new").css("display","none");
    }
});

$(".Index_dots_bundle_details_sides_innerright_innermobile_mainicons_new").click(function() {
  $(this).css("display","none");
  $(this).next(".Index_dots_bundle_details_sides_innerright_innermobile_mainitems_new").css("display","block");
})

$(".Index_dots_bundle_details_sides_innerright_innermobile_inneritems_innerclose_new").click(function() {
  $(this).parents(".Index_dots_bundle_details_sides_innerright_mainmobile_new").find(".Index_dots_bundle_details_sides_innerright_innermobile_mainicons_new").css("display","block");
  $(this).parents(".Index_dots_bundle_details_sides_innerright_mainmobile_new").find(".Index_dots_bundle_details_sides_innerright_innermobile_mainitems_new").css("display","none");
})

$('a[href^="#"]').on('click', function(event) {
  var target = $($(this).attr('href'));
  if (target.length) {
    event.preventDefault();
    $('html, body').stop().animate({
        scrollTop: target.offset().top
    }, 500);
  }
});

var target = window.location.hash;
var hash = target.substring(target.indexOf('#') + 1);
if (hash) {
  console.log(hash);
  $('html, body').stop().animate({
      scrollTop: $("#"+hash).offset().top - 200
  }, 500);

  if($("[data-tab='"+hash+"']").hasClass("active") == false)
  {
    setTimeout(function() {
      console.log($("[data-tab='"+hash+"']"));
      $("[data-tab='"+hash+"']").trigger("click");
    },700)
  }
}

$('.Megamenu_detail_2_mainbox_new a').on('click', function(event) {
  var target = $(this).attr('href');
  var hash = target.substring(target.indexOf('#') + 1);
  if (hash) {
    $('html, body').stop().animate({
        scrollTop: $("#"+hash).offset().top - 200
    }, 500);

    $(".mega-menu").removeAttr("open");
    $("[aria-controls='menu-drawer']").trigger("click");

    if($("[data-tab='"+hash+"']").hasClass("active") == false)
    {
      setTimeout(function() {
        $("[data-tab='"+hash+"']").trigger("click");
      },700)
    }
  }
});

$(".footer-block__heading").click(function() {
  var width = $(document).width();
  if(width < 750)
  {
    $(this).toggleClass("active");
    $(this).next(".footer-block__details-content").slideToggle();
  }
})

$(".youtube_video_popup").click(function() {
  $(this).parents(".Product_tabs_videos_texts_main_new").find(".youtube_video_overlay_new").fadeIn();
  $(this).parents(".Product_tabs_videos_texts_main_new").find(".youtube_video_new").fadeIn();
  $(this).parents(".Product_tabs_videos_texts_main_new").find(".youtube_video")[0].contentWindow.postMessage(
    '{"event":"command","func":"' + "playVideo" + '","args":""}',
    "*"
  );
})
$(".youtube_video_overlay_new, .youtube_video_close_new").click(function() {
  $(this).parents(".Product_tabs_videos_texts_main_new").find(".youtube_video_overlay_new").fadeOut();
  $(this).parents(".Product_tabs_videos_texts_main_new").find(".youtube_video_new").fadeOut();
  // Grab the YouTube video and ask it to pause.
  $(this).parents(".Product_tabs_videos_texts_main_new").find(".youtube_video")[0].contentWindow.postMessage(
    '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
    "*"
  );
})